import { ref, type Ref } from 'vue';

// Bridges the Monaco "Edit secret values…" code action (offered on a RESOLVABLE
// $__secret reference — one with no not-found/invalid squiggle) to the app-root
// SecretEditor. Same pattern as secretCreatePrompt.ts / serviceCreatePrompt.ts: the
// code action runs in a side-effect lib with no Vue context.
export const secretEditRequest: Ref<{ scope: string; name: string } | null> = ref(null);

export function requestEditSecret(scope: string, name: string): void {
  secretEditRequest.value = { scope, name };
}

export function clearEditSecretRequest(): void {
  secretEditRequest.value = null;
}
